export default __webpack_public_path__ + "static/media/BankruptcyImage.1e68e0de.svg";